
export class FormularioPresupuesto {
    clienteId?: number;
    titular!: string;
    nacimiento!: string;
    email!: string;
    telefono!: string;
    formaPago!: string;
    fechaInicioCobertura!: string;
    profesion!: string;
    tipoPoliza!: string;
    tipoPolizaDescripcion!: string;
    fallecimientoCausa!: number;
    fallecimientoAccidente!: number;
    invalidezAccidente!: number;
    incluidoFallecimientoAccidente?: boolean;
    incluidoInvalidezAccidente?: boolean;
    precioMensual!: number;
    nombreAgente!: string;
    emailAgente!: string;
    telefonoAgente!: string;
    urlLogo!: string;
}
